/**
 * Used for the BE call to the insights in review-insights.service.ts
 * Different methods will retrieve different statistics/insights.
 */
export enum InsightsMethod {
  NUMBER_OF_REVIEWS = 'numbers',
  RATINGS = 'ratings',
  TOP_LOCATIONS = 'locationComparisonOverview',
  LOCATION_COMPARISON_LIST = 'locationComparisonList',
  LOCATION_COMPARISON_COUNT = 'locationComparisonCount',
  RESPONDED_COMMENTED = 'respondedCommented',
  RESPONSE_TIMES = 'responseTimes',
  RESPONSE_TIMES_OVERVIEW = 'responseTimesOverview',
  POST_TIMES = 'postTimes',
  POSTS_PER_WEEKDAY = 'postsPerWeekday',
  MAP_LOCATIONS = 'mapLocations'
}
